import React, { FC } from "react";

import { ContentBox, GridItem, GridLayout } from "ui-library/layouts";

import i18n from "core/i18n";
import { maxLengthCharacters, numberCharacters } from "core/form";
import { Field } from "core/hookForm";

import useBankCodes from "../../hooks/useBankCodes";
import { VehicleCancellationFormValues } from "../../types";

type AccountSectionCsProps = {
    sectionName: "fundsTransferBankAccount";
};

export const AccountSectionCs: FC<AccountSectionCsProps> = ({ sectionName }) => {
    const { t } = i18n.useTranslation();

    // TODO: Handle failed state.
    const { bankCodes, isBankCodesFetching, isFailed } = useBankCodes();

    return (
        <>
            <ContentBox fullWidth>
                <GridLayout spacing={1}>
                    <GridItem xs={12} md={4}>
                        <Field<VehicleCancellationFormValues>
                            name={`${sectionName}.prefix`}
                            label={t("payments.targetAccountPrefix")}
                            input="textField"
                            normalize={[numberCharacters, maxLengthCharacters(6)]}
                        />
                    </GridItem>
                    <GridItem xs={12} md={8}>
                        <Field<VehicleCancellationFormValues>
                            name={`${sectionName}.accountNumber`}
                            label={t("common.accountNumber")}
                            input="textField"
                            normalize={[numberCharacters, maxLengthCharacters(10)]}
                        />
                    </GridItem>
                </GridLayout>
            </ContentBox>
            <ContentBox fullWidth>
                <GridLayout spacing={1}>
                    <GridItem xs={12}>
                        <Field<VehicleCancellationFormValues>
                            name={`${sectionName}.bankCode`}
                            label={t("payments.bankCode")}
                            input="select"
                            options={bankCodes}
                            isLoading={isBankCodesFetching}
                            includeEmptyOption={false}
                        />
                    </GridItem>
                </GridLayout>
            </ContentBox>
        </>
    );
};
